// import React from "react";
// import Select, { components } from "react-select";

// // Custom checkbox option for the dropdown
// const CheckboxOption = (props) => (
//   <components.Option {...props}>
//     <div className="flex items-center gap-2">
//       <input
//         type="checkbox"
//         checked={props.isSelected}
//         onChange={() => {}}
//         className="accent-indigo-500 w-4 h-4 rounded border-gray-300"
//       />
//       <label className="text-sm text-gray-800">{props.label}</label>
//     </div>
//   </components.Option>
// );
// const CustomMenuList = (props) => {
//   return (
//     <>
//       <components.MenuList {...props}>
//         {props.children}
//         <div
//           className="py-4 px-2 border-b-t text-indigo-600 text-sm cursor-pointer hover:underline"
//           onClick={() => props.selectProps.setSelectedValues([])}
//         >
//           Clear Filter
//         </div>
//       </components.MenuList>
//     </>
//   );
// };

// const MultiSelectDropdown = ({
//   options,
//   selectedValues,
//   setSelectedValues,
//   placeholder = "Select options...",
//   isDisabled = false,
// }) => {
//   const customStyles = {
//     control: (provided, state) => ({
//       ...provided,
//       width: "100%",
//       minHeight: "25px",
//       borderColor: state.isFocused ? "#4B5563" : "#9CA3AF", // dark gray (gray-700)0
//       borderWidth: "1px",
//       borderStyle: "dashed",
//       borderRadius: "0.5rem", // rounded-md
//       boxShadow: state.isFocused ? "0 0 0 2px #c7d2fe" : "none", // indigo-100 ring
//       "&:hover": {
//         borderColor: "#000",
//       },
//       fontSize: "0.875rem",
//       paddingLeft: "0.25rem",
//       flexWrap: "wrap", // ✅ important
//     }),
//     placeholder: (provided) => ({
//       ...provided,
//       color: "#000000", // black placeholder text
//     }),
//     menu: (provided) => ({
//       ...provided,
//       zIndex: 30,
//       borderRadius: "0.5rem",
//       boxShadow: "0px 10px 15px -3px rgba(0, 0, 0, 0.1)",
//       overflow: "hidden",
//     }),

//     option: (provided, state) => ({
//       ...provided,
//       backgroundColor: state.isSelected
//         ? "#e0e7ff" // indigo-100
//         : state.isFocused
//         ? "#f3f4f6" // gray-100
//         : "white",
//       color: "#1f2937", // gray-800
//       padding: "10px 12px",
//       fontSize: "0.875rem",
//       cursor: "pointer",
//     }),
//     multiValue: (provided) => ({
//       ...provided,
//       backgroundColor: "#e0e7ff", // indigo-100
//       borderRadius: "9999px",
//       padding: "2px 6px",
//     }),
//     multiValueLabel: (provided) => ({
//       ...provided,
//       color: "#4f46e5", // indigo-600
//       fontSize: "12px",
//     }),
//     multiValueRemove: (provided) => ({
//       ...provided,
//       color: "#4f46e5",
//       ":hover": {
//         backgroundColor: "#c7d2fe", // indigo-200
//         color: "#1e40af", // indigo-800
//       },
//     }),
//   };

//   return (
//     <div className="w-full sm:w-1/3">
//       <Select
//         isMulti
//         options={options}
//         value={selectedValues}
//         onChange={(selected) => setSelectedValues(selected || [])}
//         isDisabled={isDisabled}
//         placeholder={placeholder}
//         closeMenuOnSelect={false}
//         hideSelectedOptions={false}
//         components={{ Option: CheckboxOption, MenuList: CustomMenuList }}
//         styles={customStyles}
//         classNamePrefix="react-select"
//         setSelectedValues={setSelectedValues}
//       />
//     </div>
//   );
// };

// export default MultiSelectDropdown;
import React from "react";
import Select, { components } from "react-select";

// Custom option with checkbox
const CheckboxOption = (props) => (
  <components.Option {...props}>
    <div className="flex items-center gap-2">
      <input
        type="checkbox"
        checked={props.isSelected}
        onChange={() => {}}
        className="accent-indigo-500 w-4 h-4 rounded border border-gray-300"
      />
      <label className="text-sm text-gray-800">{props.label}</label>
    </div>
  </components.Option>
);

//  Custom "Clear Filter" option
const CustomMenuList = (props) => (
  <components.MenuList {...props}>
    {props.children}
    <div
      className="py-2 px-2 border-t text-indigo-600 text-sm cursor-pointer hover:underline"
      onClick={() => props.selectProps.setSelectedValues([])}
    >
      Clear Filter
    </div>
  </components.MenuList>
);

//  Hide selected values & prevent space above placeholder
const CustomValueContainer = ({ children, ...props }) => {
  const selectedOptions = props.getValue();
  const hasValue = selectedOptions.length > 0;

  const clearAll = (e) => {
    e.stopPropagation(); // Prevent dropdown toggle
    props.selectProps.onChange([], { action: "clear" });
  };

  return (
    <components.ValueContainer {...props}>
      {!hasValue ? (
        <components.Placeholder {...props}>
          {props.selectProps.placeholder}
        </components.Placeholder>
      ) : (
        <div className="flex items-center space-x-2 text-sm text-amber-600 font-medium whitespace-nowrap">
          <span>
            {selectedOptions.length} option
            {selectedOptions.length > 1 ? "s" : ""} selected
          </span>
          <button
            type="button"
            onClick={clearAll}
            className="text-amber-600 hover:text-amber-700 focus:outline-none"
            aria-label="Clear selected options"
          >
            &#10005; {/* Unicode X */}
          </button>
        </div>
      )}
      {children[1]}
    </components.ValueContainer>
  );
};

const MultiSelectDropdown = ({
  options,
  selectedValues,
  setSelectedValues,
  placeholder = "Select options...",
  isDisabled = false,
}) => {
  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      width: "100%",
      height: "36px",
      borderColor: state.isFocused ? "#030712" : "#030712",
      borderWidth: "1px",
      // borderStyle: "dashed",
      borderRadius: "0.5rem",
      boxShadow: state.isFocused ? "0 0 0 2px #c7d2fe" : "none",
      "&:hover": {
        borderColor: "#000",
      },
      fontSize: "0.875rem",
      paddingLeft: "0.25rem",
      display: "flex",
      alignItems: "center",
    }),
    placeholder: (provided) => ({
      ...provided,
      color: "#000000",
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 30,
      borderRadius: "0.5rem",
      boxShadow: "0px 10px 15px -3px rgba(0, 0, 0, 0.1)",
      overflow: "hidden",
    }),
    menuPortal: (provided) => ({
      ...provided,
      zIndex: 9999,
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? "#e0e7ff"
        : state.isFocused
        ? "#f3f4f6"
        : "white",
      color: "#1f2937",
      padding: "10px 12px",
      fontSize: "0.875rem",
      cursor: "pointer",
    }),
    // 👇 Hide all internal multiValue elements
    multiValue: () => ({ display: "none" }),
    multiValueLabel: () => ({ display: "none" }),
    multiValueRemove: () => ({ display: "none" }),
  };

  return (
    <div className="w-full sm:w-1/2">
      <Select
        isMulti
        options={options}
        menuPortalTarget={document.body}
  menuPosition="fixed"
        value={selectedValues}
        onChange={(selected) => setSelectedValues(selected || [])}
        isDisabled={isDisabled}
        placeholder={placeholder}
        closeMenuOnSelect={false}
        hideSelectedOptions={false}
        components={{
          Option: CheckboxOption,
          MenuList: CustomMenuList,
          ValueContainer: CustomValueContainer,
        }}
        styles={customStyles}
        classNamePrefix="react-select"
        setSelectedValues={setSelectedValues}
        isClearable={false}
      />
    </div>
  );
};

export default MultiSelectDropdown;
